// src/pages/SubBranch.jsx
import React from "react";
import img1 from "../assets/products/img4.png";
import infra1 from "../assets/products/infra1.png";
import infra2 from "../assets/products/infra2.png";
import sub1 from "../assets/subbranch/sub1 (1).jpg";
import sub2 from "../assets/subbranch/sub1 (7).jpg";
import sub3 from "../assets/subbranch/sub1 (3).jpg";
import sub4 from "../assets/subbranch/sub1 (10).jpg";
import sub5 from "../assets/subbranch/sub1 (17).jpg";
import sub6 from "../assets/subbranch/sub1 (9).jpg";
import sub7 from "../assets/subbranch/sub1 (2).jpg";


const SubBranch = () => {
  const industryImages = [sub4, sub2, sub3, sub1, sub5, sub6, sub7];

  return (
    <section className="py-20 bg-blue-200">
    <div className="bg-white min-h-screen text-black">
      {/* Hero Section */}
      <section className="px-6 bg-white sm:px-10 md:px-24 py-16 sm:py-24 text-center">
        <img
          src={img1}
          alt="Sub Branch Hero"
          className="w-[60%] max-w-3xl mx-auto rounded-2xl shadow-lg mb-8 transition-transform duration-500 hover:scale-105"
        />
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold leading-tight">
          Unit 2 – Infrastructure, Facilities & Future Expansion
        </h1>
        <p className="mt-4 text-lg sm:text-xl text-gray-600 max-w-4xl mx-auto">
          Unit 2 is strategically developed on a vast 3,900-acre land area,
          providing ample space for current operations and future growth. The
          facility comprises a 7,000 sq. ft. built-up area across the Ground,
          First, and Second Floors, designed with a structured layout that
          optimizes production flow, ensures safety, and supports scalability.
        </p>
      </section>

      {/* Facilities Section */}
      <section className="px-6 bg-blue-200 sm:px-10 md:px-24 pb-16">
        <h2 className="text-3xl font-bold mb-8 text-center">Facilities View</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
          <div className="rounded-lg overflow-hidden shadow-lg">
            <img
              src={infra1}
              alt="Infrastructure - Inside View"
              className="w-full h-[300px] object-cover hover:scale-105 transition-transform duration-300"
            />
            <p className="text-center mt-3 font-medium text-gray-700">
              Spacious Interior Facility
            </p>
          </div>
          <div className="rounded-lg overflow-hidden shadow-lg">
            <img
              src={infra2}
              alt="Infrastructure - Terrace View"
              className="w-full h-[300px] object-cover hover:scale-105 transition-transform duration-300"
            />
            <p className="text-center mt-3 font-medium text-gray-700">
              Open Terrace Area
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="px-6 bg-blue-200 sm:px-10 md:px-24 pb-16 space-y-12 text-gray-800">
        <div>
          <h2 className="text-3xl font-bold mb-4">Infrastructure</h2>
          <p>
            The unit integrates dedicated zones for machining, quality
            inspection, storage, and utilities, enabling seamless coordination
            across operations. This infrastructure positions Unit 2 as a modern
            manufacturing hub capable of delivering precision-engineered
            components consistently.
          </p>
        </div>

        <div>
          <h2 className="text-3xl font-bold mb-4">Current Facilities</h2>
          <ul className="list-disc list-inside space-y-2">
            <li>CNC Turning Centers</li>
            <li>Semi-Automatic Traub Machines</li>
            <li>Conventional Lathe Machines</li>
            <li>Drilling Machines</li>
            <li>Thread Rolling Machines</li>
            <li>Bench Grinding Machines</li>
            <li>Oil Dryer System</li>
            <li>Electronic Weighing Machines</li>
          </ul>
        </div>

      

        <div>
          <h2 className="text-3xl font-bold mb-4">Customer Benefits</h2>
          <ul className="list-disc list-inside space-y-2">
            <li>End-to-end solutions under one roof</li>
            <li>Faster lead times and consistent quality</li>
            <li>Durable, precision-engineered components</li>
            <li>Scalable infrastructure</li>
          </ul>
        </div>

        {/* Industry View Grid */}
        <div>
          <h2 className="text-3xl font-bold mb-8 text-center">Industry View</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {industryImages.map((img, idx) => (
              <div
                key={idx}
                className="relative rounded-xl overflow-hidden shadow-lg group transition-all duration-500 hover:shadow-2xl hover:-translate-y-2"
              >
                <img
                  src={img}
                  alt={`Industry ${idx + 1}`}
                  className="w-full h-64 sm:h-72 md:h-80 object-cover transform transition-transform duration-500 group-hover:scale-110 group-hover:rotate-1"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-yellow-400 via-transparent to-transparent opacity-0 group-hover:opacity-40 transition-opacity duration-500 rounded-xl"></div>
              </div>
            ))}
          </div>
        </div>
          <div>
          <h2 className="text-3xl font-bold mb-4">Future Expansion Plans</h2>
          <p className="mb-4">
            Unit 2 has a clear roadmap for expansion with a focus on advanced
            processes, automation, and value-added capabilities.
          </p>
          <ul className="list-disc list-inside space-y-2">
            <li>Induction Hardening Facility</li>
            <li>CNC Vertical Machining Centers (VMCs)</li>
            <li>Automatic Bandsaw Machines</li>
            <li>Grinding Machines (Centerless & Surface)</li>
            <li>Hydraulic Presses</li>
            <li>Surface Treatment Equipment</li>
            <li>Advanced Testing & Measuring Instruments</li>
          </ul>
        </div>

        {/* Map Section */}
        <div className="w-full h-[250px] sm:h-[350px] md:h-[450px] lg:h-[500px] rounded-lg overflow-hidden shadow-lg mt-16">
          <iframe
            title="Twin Star Industries Sub Branch Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.996330051252!2d80.2477361!3d12.972086299999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525db466a0b7f9%3A0x333745e7cd0cdcc1!2sNo.346%2C%204th%20St%2C%20Nehru%20Nagar%2C%20Kottivakkam%2C%20Chennai%2C%20Tamil%20Nadu%20600041!5e0!3m2!1sen!2sin!4v1756959655466!5m2!1sen!2sin"
            width="100%"
            height="100%"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>
    </div>
    </section>
  );
};

export default SubBranch;
